import React, { Fragment, HTMLAttributes, useRef } from 'react';
import { Route, Switch, withRouter, RouteProps } from 'react-router';
import { compose } from 'redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { EBreakpoints, BreakpointsValues, breakpointValue } from 'pureUi/breakpoints';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { Container } from './styles';

interface NavigationLayoutProps extends HTMLAttributes<HTMLDivElement> {
  menu: React.ReactNode;
  menuPath: string;
}

export interface NavigationLayoutConnectedProps extends NavigationLayoutProps, Omit<RouteProps, 'children'> {
  currentBreakpoint?: EBreakpoints;
  breakpoints?: BreakpointsValues;
}

export const NavigationLayout = (props: NavigationLayoutConnectedProps) => {
  const { className, menu, menuPath, children, currentBreakpoint: currentBreakpointProp, location } = props;
  const hookBreakpoint = useBreakpoint();
  const currentBreakpoint = currentBreakpointProp ?? hookBreakpoint;
  const isMobileView = breakpointValue(currentBreakpoint) < breakpointValue(EBreakpoints.TABLET_UP);
  const isMenuView = menuPath === location?.pathname;
  const transitionKey = location?.key ?? location?.pathname ?? 'navigation-layout';
  const transitionNodeRefs = useRef<Record<string, { current: HTMLDivElement | null }>>({});

  if (!transitionNodeRefs.current[transitionKey]) {
    transitionNodeRefs.current[transitionKey] = { current: null };
  }

  const transitionNodeRef = transitionNodeRefs.current[transitionKey];

  return (
    <Container className={classNames(className, { mobile: isMobileView })}>
      {isMobileView ? (
          <main>
            <TransitionGroup className="animation-container">
              <CSSTransition
                key={transitionKey}
                classNames={`animate ${isMenuView ? 'in' : 'out'}`}
                timeout={300}
                nodeRef={transitionNodeRef}
              >
                <div ref={transitionNodeRef}>
                  {/* @ts-ignore */}
                  <Switch location={location}>
                    <Route exact path={menuPath}>{menu}</Route>
                    {children}
                  </Switch>
                </div>
              </CSSTransition>
            </TransitionGroup>
          </main>
        )
        : (
          <Fragment>
            <aside>{menu}</aside>
            <main>{children}</main>
          </Fragment>
        )
      }
    </Container>
  );
};


export const NavigationLayoutConnected = compose<React.ComponentType<NavigationLayoutProps>>(
  withRouter
)(NavigationLayout);

